import { Form, Formik, Field } from "formik";

import { AvailableTemplate } from "src/models/AvailableTemplates";
import {
    CheckBoxField,
    ChoiceField,
    ListCollectorField,
    ReferenceField,
    StringField,
    TextAreaField
} from "../form/CustomFormikComponents";
import { FormInput, setInitialProcessInputs } from "src/models/UserInputs";

type Props = {
    template: AvailableTemplate;
    formRef: any;
};

export default function SetProcessInputs({ template, formRef }: Props) {
    const processInputs = template.processInputs;

    const initialValues = setInitialProcessInputs(processInputs);
    return (
        // the submit part of the form is handled in CreateTemplateRun
        <Formik initialValues={initialValues} onSubmit={() => {}} innerRef={formRef}>
            {({ values }) => {
                return (
                    <Form>
                        {Object.entries(processInputs).map(([k, v]) =>
                            getComponent(k, v as FormInput, template.companySysId)
                        )}
                        {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                    </Form>
                );
            }}
        </Formik>
    );
}

function getComponent(k: string, v: FormInput, companyId: string) {
    switch (v.type) {
        case "string":
        case "maskedstring":
            return (
                <Field
                    name={`${k}.value`}
                    key={k}
                    label={v.label}
                    type={v.type}
                    required={v.required}
                    as={StringField}
                />
            );
        case "textarea":
            return <Field name={`${k}.value`} key={k} label={v.label} required={v.required} as={TextAreaField} />;
        case "checkbox":
            return <Field name={`${k}.value`} key={k} label={v.label} as={CheckBoxField} />;
        case "choice":
            return (
                <Field
                    name={`${k}.value`}
                    key={k}
                    label={v.label}
                    required={v.required}
                    choices={v.choices}
                    as={ChoiceField}
                />
            );
        case "reference":
            return (
                <Field
                    name={k}
                    key={k}
                    label={v.label}
                    required={v.required}
                    companyId={companyId}
                    tableRef={v.snTableNameRef}
                    as={ReferenceField}
                />
            );
        case "listcollector":
            return (
                <Field
                    name={`${k}`}
                    key={k}
                    label={v.label}
                    required={v.required}
                    companyId={companyId}
                    tableRef={v.snTableNameRef}
                    as={ListCollectorField}
                />
            );
        default:
            return undefined;
    }
}
